export default __webpack_public_path__ + "static/media/team115.4354ab63.JPG";